import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { map, Observable, Subject } from 'rxjs';
import { environment } from '../../environments/environment';
import { MessageServiceService } from './message-service.service';

@Injectable({
    providedIn: 'root'
})

export class CarrelloViniService {
    setInfoLayout(infoLayout: { codiceForm: any; layout: number; liungua: string; }) {
        throw new Error('Method not implemented.');
    }

    public cantinaDenominazione: string;
    public richiediDatiFiscaliRicevuta: boolean;

    public currentStep: number;

    public admPagaCantina = false;
    public admPagaCantinaSC = false;
    public supplementoSC = 0;
    public supplementoAttivo = false;
    public pagaCantinaInsite = false;

    public currentVisita: any;

    public infoLayoutVini = {};

    nrRighe = new Subject<number>();

    constructor(
        private cookieService: CookieService,
        private http: HttpClient,
        private messageService: MessageServiceService
    ) { }

    checkCarrelloQta(idUtente: number): Observable<any> {
        return this.http.get(environment.apiUrl + 'public/checkcarrelloqta/' + idUtente + '/' + this.messageService.getIdCookie() + '/')
            .pipe(map(response => {
                this.nrRighe.next(parseInt(response['nrighe'], 10));
            }));
    }

    setInfoLayoutVini(infoLayoutVini) {
        this.infoLayoutVini = infoLayoutVini;
    }

    getInfoLayoutVini() {
        return this.infoLayoutVini;
    }

    removeIdCliente(): Observable<any> {
        const valori = {
            tipo: 'remove-id-cliente-insite',
            idCookie: this.messageService.getIdCookie()
        }

        return this.http.put(environment.apiUrl + 'public/', JSON.stringify(valori))
            .pipe(map(response => {
                return response;
            }));
    }

    checkPresenzaNelCarrelloIframe(idCliente, idVisita: number, nposti: number): Observable<any> {
        return this.http.get(environment.apiUrl + 'public/checknelcarrello/' + idVisita + '/' + idCliente + '/' + nposti + '/' + this.messageService.getIdCookie() + '/')
            .pipe(map(response => {
                return response;
            }));
    }

    addCarrello(
        tipo: 'carrello' | 'carrelloBuono' | 'carrelloBuonoCantina' | 'carrelloPacchetto' | 'carrello_tourbus' | 'carrelloVino',
        valori
    ): Observable<any> {
        valori.tipo = tipo;
        valori.idCookie = this.messageService.getIdCookie();
        return this.http.post(environment.apiUrl + 'public/', JSON.stringify(valori))
            .pipe(map(response => {
                this.checkCarrelloQta(valori.idCliente).subscribe();
                response['idCookie'] = valori.idCookie
                return response;
            }));
    }

    getCarrello(): Observable<any> {
        let idCookie = this.messageService.getIdCookie();
        return this.http.get(environment.apiUrl + 'public/carrello/it/null/' + idCookie + '/')
            .pipe(map(response => {
                response['idCookie'] = idCookie;
                return response;
            }));
    }

    controllaCodiceScontoCarrello(codice): Observable<any> {
        return this.http.get(environment.apiUrl + 'public/checkcodicescontocarrello/' + codice + '/')
            .pipe(map(response => {
                return response;
            }));
    }

    rimuoviDalCarrelloBuoniCantina(idCarrelloBuoniCantina: number, idUtente): Observable<any> {
        return this.http.delete(environment.apiUrl + 'public/carrellobuonicantina/null/' + idCarrelloBuoniCantina + '/')
            .pipe(map(response => {
                this.checkCarrelloQta(idUtente).subscribe();
                return response;
            }));
    }

    rimuoviDalCarrelloVinoSingolo(idCarrelloVini: any, idUtente): Observable<any> {
        return this.http.delete(environment.apiUrl + 'public/carrellovinisingolo/null/' + idCarrelloVini + '/')
            .pipe(map(response => {
                this.checkCarrelloQta(idUtente).subscribe();
                return response;
            }));
    }

    rimuoviDalCarrello(idCarrello: number, idUtente: number): Observable<any> {
        return this.http.delete(environment.apiUrl + 'public/carrello/null/' + idCarrello + '/')
            .pipe(map(response => {
                this.checkCarrelloQta(idUtente).subscribe();
                return response;
            }));
    }

    rimuoviDalCarrelloPacchetti(idCarrello: number, idUtente: number): Observable<any> {
        return this.http.delete(environment.apiUrl + 'public/carrellopacchetti/null/' + idCarrello + '/')
            .pipe(map(response => {
                this.checkCarrelloQta(idUtente).subscribe();
                return response;
            }));
    }

    rimuoviDalCarrelloSC(idCarrelloSC: number, idUtente: number): Observable<any> {
        return this.http.delete(environment.apiUrl + 'public/carrelloSC/null/' + idCarrelloSC + '/')
            .pipe(map(response => {
                this.checkCarrelloQta(idUtente).subscribe();
                return response;
            }));
    }

    rimuoviDalCarrelloVini(idCarrelloVini: any, idUtente: number): Observable<any> {
        return this.http.delete(environment.apiUrl + 'public/carrellovini/null/' + idCarrelloVini + '/')
            .pipe(map(response => {
                this.checkCarrelloQta(idUtente).subscribe();
                return response;
            }));
    }
}
